<template>
  <div class="box6">
   <img src="../../../assets/coursePage/trainer/06.png"/>
  </div>
</template>

<script>


export default {
 
  data() {
    return {
 
    };
  },
};
</script>

<style lang="less" scoped>
.box6{
  width: 100%;
 img{
  width: 100%;
  display: block;
 }
  
}
</style>
